import React, { cloneElement, isValidElement, useEffect, useState } from 'react'
import { BaseButton } from 'iebt-zing-storybook'
import { FilterRow, SearchCol, SearchContainer, SearchIcon, SearchInput, DesktopButtons, MobileButtons } from './styles'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Tippy from '@tippyjs/react'
import { trans } from 'sharedKernel/i18n'
import { Col } from 'react-bootstrap'

export interface FilterProps {
  btnClick?: Function
  currentSearchTerm?: string
  searchBtn?: boolean
  searchPlaceholder?: string
  onFilterChange?: (val) => void
  minSearchTermLength?: number
  filterButtonNode?: React.ReactNode
  filterBarRef?: React.RefObject<HTMLDivElement | null>
}

export const Filter = ({
  btnClick = () => { },
  currentSearchTerm = '',
  searchBtn = true,
  searchPlaceholder,
  onFilterChange,
  minSearchTermLength = 3,
  filterButtonNode,
  filterBarRef
}: FilterProps): JSX.Element => {
  const [termSearched, setTermSearched] = useState<string>('')
  const [hasSearched, setHasSearched] = useState<boolean>(false)

  const labels = {
    search: trans('Buscar'),
    clear: trans('Limpar'),
    searchPlaceholder: searchPlaceholder ?? trans('Insira aqui os termos da sua pesquisa'),
    tooltipMessage: trans('Termo insuficiente')
  }

    const isSearchDisabled = (): boolean => {
        return termSearched.length < minSearchTermLength
    }

  useEffect(() => {
    setTermSearched(currentSearchTerm)
    if (currentSearchTerm === '') {
      setHasSearched(false)
    }
  }, [currentSearchTerm])

  const handleSearch = () => {
    btnClick(termSearched)
    setHasSearched(true)
  }

  const handleClear = () => {
    btnClick('')
    setTermSearched('')
    setHasSearched(false)
    if (onFilterChange !== undefined) {
      onFilterChange('')
    }
  }

  const buscarButton = (
    <Tippy
      content={labels.tooltipMessage}
      animation="scale"
      disabled={!isSearchDisabled()}
    >
      <div className="pl-1" style={{ height: '32px', width: '89px', display: 'flex', alignItems: 'center' }}>
        <BaseButton
          disabled={isSearchDisabled()}
          btnContent={labels.search}
          variant='primary-invert'
          size='medium'
          onClick={handleSearch}
        />
      </div>
    </Tippy>
  )

  const limparButton = (
    <div className="pl-1" style={{ height: '32px', width: '89px', display: 'flex', alignItems: 'center' }}>
      <BaseButton
        btnContent={labels.clear}
        variant='primary-invert'
        size='medium'
        onClick={handleClear}
      />
    </div>
  )

  return (
    <FilterRow className="align-items-center" style={{ flexWrap: 'nowrap' }}>
      <SearchCol xs={9} sm={9} md={9} lg={9} className='p-0'>
        <SearchContainer>
          <SearchIcon id="basic-addon1">
            <FontAwesomeIcon icon={['fas', 'magnifying-glass']} color="var(--grey-lighter)" />
          </SearchIcon>
          <SearchInput
            id="inlineFormInput"
            placeholder={labels.searchPlaceholder}
            title={labels.searchPlaceholder}
            aria-describedby="basic-addon1"
            type="text"
            value={termSearched}
            onChange={(event) => {
              setTermSearched(event.target.value)
              setHasSearched(false)
              if (onFilterChange !== undefined) {
                onFilterChange(event.target.value)
              }
              if (event.target.value === '') {
                btnClick(event.target.value)
              }
            }}
          />
        </SearchContainer>
      </SearchCol>

      <Col xs={3} sm={3} md={3} lg={3} className="d-flex align-items-center" style={{ flex: '0 0 auto', padding: '0rem', width: '25%' }}>
        {/* Desktop: comportamento original */}
        <DesktopButtons>
          {searchBtn && buscarButton}
          {termSearched !== '' && limparButton}
        </DesktopButtons>

        {/* Mobile: alterna entre Filtrar → Buscar → Limpar */}
        <MobileButtons>
          {hasSearched
            ? limparButton
            : termSearched !== ''
              ? buscarButton
              : (filterButtonNode != null && isValidElement(filterButtonNode) && filterBarRef != null
                  ? cloneElement(filterButtonNode as React.ReactElement<{ filterBarRef?: React.RefObject<HTMLDivElement | null> }>, { filterBarRef })
                  : (filterButtonNode ?? null))
          }
        </MobileButtons>
      </Col>
    </FilterRow>
  )
}
